import { Link } from 'react-router-dom';

export default function Thanks() {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 md:px-6 py-20 overflow-hidden bg-[#0d0d1a]">
      <div
        className="blob w-[500px] h-[500px] top-0 left-1/2 -translate-x-1/2"
        style={{ background: 'linear-gradient(135deg, #7c3aed, #a855f7)' }}
      ></div>

      <div className="relative z-10 text-center max-w-xl mx-auto">
        <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-r from-[#7c3aed] to-[#a855f7] flex items-center justify-center animate-float">
          <i className="ri-check-line text-white text-4xl"></i>
        </div>
        <h1 className="mt-8 text-3xl md:text-4xl font-extrabold text-white">お問い合わせありがとうございます</h1>
        <p className="mt-5 text-[#a0a0b0] text-base md:text-lg leading-relaxed">
          2営業日以内にご連絡いたします。
        </p>
        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl h-12 px-8 text-sm font-semibold bg-gradient-to-r from-[#7c3aed] to-[#a855f7] text-white transition-all duration-300 hover:brightness-110 hover:scale-[1.02] hover:shadow-[0_14px_30px_rgba(124,58,237,0.4)]"
          >
            <i className="ri-home-4-line"></i>
            トップページへ戻る
          </Link>
        </div>
      </div>
    </section>
  );
}